"use client"
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import { FaSadTear } from "react-icons/fa";

const ErrorScreen = () => {
  const t = useTranslations("ErrorPage");
  const router = useRouter();

  return (
    <div className="relative flex justify-center items-center h-screen bg-white perspective-3d">
      {/* Logo Central */}
      <div className="absolute top-1/3 flex flex-col justify-center items-center text-center">
        <div className="max-w-md w-full">
          <FaSadTear className="text-primary text-6xl mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-black-900 mb-2">
            {t("title")}
          </h1>
          <p className="text-black-600 mb-6">
            {t("subtitle")}
          </p>
          <p className="text-sm text-black-500 mb-6">
            {t("body")}
          </p>
          <div className="flex justify-center gap-4">
            <button
              onClick={() => router.push("/")}
              className="bg-primary text-white font-semibold py-2 px-6 rounded-lg hover:bg-primary-800 transition duration-300"
            >
              {t("button_back")}
            </button>
          </div>
        </div>
      </div>

      {/* Cubos Caindo */}
      {Array.from({ length: 10 }).map((_, i) => {
        const animationDuration = `${Math.random() * 4 + 2}s`;
        const animationDelay = `${Math.random()}s`;
        return (
          <div
            key={i}
            className="cube"
            style={{
              top: `${Math.random() - 10}%`,
              left: `${Math.random() * 100}%`,
              animationDuration,
              animationDelay,
            }}
          >
            <div
              className="animate-disappear face front"
              style={{ animationDuration, animationDelay }}
            />
            <div
              className="animate-disappear face back"
              style={{ animationDuration, animationDelay }}
            />
            <div
              className="animate-disappear face left"
              style={{ animationDuration, animationDelay }}
            />
            <div
              className="animate-disappear face right"
              style={{ animationDuration, animationDelay }}
            />
            <div
              className="animate-disappear face top"
              style={{ animationDuration, animationDelay }}
            />
            <div
              className="animate-disappear face bottom"
              style={{ animationDuration, animationDelay }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ErrorScreen;
